import { getRequest, postRequest } from "./api";
import { API_URLS } from "./appUrls";

import { APP_SCOPE } from "../constants/global.constants";

const normalizeEmail = (value = "") => value.toString().trim().toLowerCase();

export const getUserLicenseData = (data) => {
  const url = `${API_URLS.admin}/${API_URLS.license}/${API_URLS.users}`;
  return postRequest(url, data, {
    overrideAppScope: APP_SCOPE.BASE,
  });
};

export const getLicensePermission = (params) => {
  const url = `${API_URLS.admin}/${API_URLS.license}/${API_URLS.permissions}`;
  return getRequest(url, { params, overrideAppScope: APP_SCOPE.BASE });
};

export const userLicenseValidate = async (email) => {
  const url = `${API_URLS.admin}/${API_URLS.license}/${API_URLS.users}`;
  const data = {
    licenses: [],
    companyName: "",
    searchstr: email,
    pageNumber: 1,
    pageSize: 20,
    sortBy: "",
    sortDirection: "",
    fromDate: "",
    toDate: "",
  };

  const responseData = await postRequest(url, data, {
    overrideAppScope: APP_SCOPE.BASE,
  });
  const users = responseData?.userRoleLicenses || [];
  const matchedUser = users.find(
    (user) => normalizeEmail(user?.email) === normalizeEmail(email),
  );

  if (!matchedUser) {
    return Promise.reject({
      response: { data: { message: "User not found in the system" } },
    });
  }

  return { data: [matchedUser] };
};

export const assignUsersLicense = (data) => {
  const url = `${API_URLS.admin}/${API_URLS.license}/${API_URLS.assign}`;
  const res = postRequest(url, data, {
    overrideAppScope: APP_SCOPE.BASE,
  });
  return res;
};

export const terminateUsersLicense = (data) => {
  const url = `${API_URLS.admin}/${API_URLS.license}/${API_URLS.terminate}`;
  const res = postRequest(url, data, {
    overrideAppScope: APP_SCOPE.BASE,
  });
  return res;
};
